import React,  { useReducer, useEffect } from "react";
import styled from "styled-components";

const Tab = styled.button`
  font-size: 15px;
  padding: 2px 7px 2px 7px;
  cursor: pointer;
  background: #3e3e3e;
  border: 0;
  outline: 0;
  border-radius: 1px;
  border: 1px solid black;
  min-width: 98px;
  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid black;
    background: #797979;
  `}
`;

const ButtonGroup = styled.div`
  display: flex;
`;

const types = ["Pending", "Approved", "Rejected", "All Releases"];

const reducer = (state, action) => {
  if (action.type === "SET_STATUS") {
    return  {
      ...state,
      status: action.status,
    }
    } else {
      return state
  }
  };
  const initialState = {
    status: types[3],
  };

const Tabs = ({onTabSelection}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const {
        status,
      } = state;

    useEffect(() => {
        if (status) {
            onTabSelection(status);
        }
      }, [status]);


    return (
          <ButtonGroup>
            {types.map((type) => (
              <Tab
                key={type}
                active={status === type}
                onClick={() => {
                    dispatch({ type: "SET_STATUS", status: type}); 
                    }
                }
              >
                <span style={{
          color: "#ffffff",
        }}>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
              </Tab>
            ))}
          </ButtonGroup>
      );
};
export default Tabs;